import React, { createContext, useState, useCallback, useEffect, PropsWithChildren } from "react";
import { AnalyticsBrowser, Analytics, InitOptions } from "@segment/analytics-next";

import { segmentWriteKey as writeKey } from "src/constants";

export interface AnalyticsContextProps {
  analytics: Analytics | undefined;
}

let integrations: InitOptions["integrations"] = { All: false, "Segment.io": true };

if (process.env.NODE_ENV === "development") {
  integrations = { All: false };
}

export const AnalyticsContext = createContext<AnalyticsContextProps>({ analytics: undefined });

export const AnalyticsProvider: React.FC<PropsWithChildren<{}>> = ({ children }) => {
  const [analytics, setAnalytics] = useState<Analytics | undefined>(undefined);
  const loadAnalytics = useCallback(async () => {
    if (!writeKey || analytics) {
      return;
    }
    const [response] = await AnalyticsBrowser.load({ writeKey }, { integrations });

    setAnalytics(response);
  }, [analytics]);

  useEffect(() => {
    // eslint-disable-next-line no-console
    loadAnalytics().catch((error) => console.error(error));
  }, [loadAnalytics]);

  return <AnalyticsContext.Provider value={{ analytics }}>{children}</AnalyticsContext.Provider>;
};
